import React, { useState, useEffect } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
import { ReactComponent as DrpDwnIcon } from "./../../resources/images/icons/DrpDwnIcon.svg";
import { ReactComponent as CoinIcon } from "./../../resources/images/icons/coin-icon.svg";
import Switch from "../common/Switch/Switch";
import DateSelector from "../common/DateSelector/DateSelector";
import SelectInput from "../common/SelectInput/SelectInput";
import { useGetRenewJobDetailsMutation } from "../../redux/apis/manageJobPostingHooks";
import { JobsDataType } from "../../types/api-response";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  modalData?: JobsDataType[] | null;
}

const LowInventoryModal = ({ isOpen, setIsOpen, modalData }: Props) => {

  const Header = (
    <MHeader>
      <span className="mjp-modal-text-header-lowInventory">Can’t renew</span>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="lowInventroy-jobs-footer">
        <div style={{ width: "25%" }}>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-renew-jobs"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        header={Header}
        footer={Footer}
        // closeIcon={<CloseIcon />}
        width="369px"
      >
        <div className="mjp-modal-body renew-jobs-body">
          {/* <div className="mjp-modal-body-greybox">
            <h5>Product Manager at Capgemini</h5>
            <p>Permanent Full time</p>
          </div> */}
          <div className="lowInventroy-content">
            <p className="lowInventroy-content-pt">
              You don’t have enough credits.{" "}
            </p>
            <p className="lowInventroy-content-st">
              For credit request write on{" "}
              <span className="lowInventroy-content-sts">cr@foundit.ai</span>
            </p>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default LowInventoryModal;
